import React from 'react';
import { WeezHeader } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import css from './styles.module.css';
import Steps from './components/Steps';
import { useTrackingPage } from '../../../components/tracking/trackingProvider';

function AddAttendee({ organization, event, isAddAttendees = true }) {
    const { t } = useTranslation();

    useTrackingPage('VIEW - ADD ATTENDEES', { 'Page Title': 'ADD ATTENDEES' });
    return (
        <div id="add-attendees">
            <WeezHeader title={t('attendees.addAttendees.title')} className={css['add-attendees-header']}>
                {t('attendees.addAttendees.subtitle')}
            </WeezHeader>
            <Steps organization={organization} event={event} isAddAttendees={isAddAttendees} />
        </div>
    );
}

export default AddAttendee;
